
// Frequently Boughts section

let productVariantIds = [];
let totalPrice = 0;

function updateMainProductPrice() {
  const mainProduct = document.querySelector('.main-product');
  if (!mainProduct) return;

  const dropdown = mainProduct.querySelector('.variant-dropdown');
  if (!dropdown) return;

  const selected = dropdown.selectedOptions[0];
  const priceEl = mainProduct.querySelector('.product-info .price');

  if (priceEl) priceEl.textContent = selected.dataset.price;

  updateProductVariants();
}

function updateSuggestedProductPrice(dropdown) {
  const wrap = dropdown.closest('.suggested-product');
  if (!wrap) return;

  const selected = dropdown.selectedOptions[0];
  const priceEl = wrap.querySelector('.suggested-product-info .price');

  if (priceEl) priceEl.textContent = selected.dataset.price;
}

function updateProductVariants() {
  productVariantIds = [];
  totalPrice = 0;

  const mainProduct = document.querySelector('.main-product');
  if (mainProduct) {
    const variantId =
      mainProduct.querySelector('.variant-dropdown')?.value ||
      mainProduct.dataset.productVariantId;

    const priceEl = mainProduct.querySelector('.product-info .price');
    const price = priceEl
      ? parseFloat(priceEl.textContent.replace(/[^0-9.-]+/g, ""))
      : 0;

    productVariantIds.push(variantId);
    totalPrice += price;
  }

  document.querySelectorAll('.suggested-product').forEach(el => {
    const variantId =
      el.querySelector('.variant-dropdown')?.value ||
      el.dataset.productVariantId;

    const priceEl = el.querySelector('.suggested-product-info .price');
    const price = priceEl
      ? parseFloat(priceEl.textContent.replace(/[^0-9.-]+/g, ""))
      : 0;

    productVariantIds.push(variantId);
    totalPrice += price;
  });

  // Update total price
  const totalEl = document.getElementById('total-price');
  if (totalEl) totalEl.textContent = '$' + totalPrice.toFixed(2);

  // Discount
  const discountEl = document.querySelector(".frequently_boughts-info .discounts .value");
  if (discountEl) {
    const discountPercentage = parseFloat(discountEl.textContent);
    const discounted = totalPrice - (discountPercentage / 100) * totalPrice;
    const discountDisplay = document.querySelector(".discounted-Price");
    if (discountDisplay) discountDisplay.textContent = '$' + discounted.toFixed(2);
  }
}

updateProductVariants();

// Dropdown listeners
document.querySelectorAll('.variant-dropdown').forEach(dropdown => {
  dropdown.addEventListener('change', () => {
    if (dropdown.closest('.main-product')) {
      updateMainProductPrice();
    } else {
      updateSuggestedProductPrice(dropdown);
    }
    updateProductVariants();
  });
});

// ADD TO CART (single API request)
async function addProductsToCart() {
  const lineItems = productVariantIds.map(id => ({
    id,
    quantity: 1
  }));

  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: lineItems })
  });
}

document.querySelector('.add-to-cart-F-B')?.addEventListener('click', async e => {
  e.preventDefault();
  await addProductsToCart();

  theme.cart.getCartProductMarkup().then(html => {
    const cartForm = new theme.CartForm(document.getElementById('CartDrawerForm'));
    cartForm.cartMarkup(html);
  });

  document.dispatchEvent(new CustomEvent('cart:open'));
});
